import { render, staticRenderFns } from "./SiapaKami.vue?vue&type=template&id=1188e5d4&scoped=true"
import script from "./SiapaKami.vue?vue&type=script&lang=js"
export * from "./SiapaKami.vue?vue&type=script&lang=js"
import style0 from "./SiapaKami.vue?vue&type=style&index=0&id=1188e5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1188e5d4",
  null
  
)

export default component.exports